import React from 'react';

const RefundHistory = ({ initLoading, data, initError, retry }) => {
  return (
    <>
      <div className="d-flex align-items-center fw-700 text-18 text-blue-1 mt-20">
        {initLoading && !initError ? <span>Loading...</span> : <span>History Log</span>}
      </div>
      {!initLoading && initError && (
        <p className="text-dark text-600">
          Gagal, Periksa koneksi internet anda dan{' '}
          <span onClick={retry} className="fw-700 cursor-pointer text-danger">
            coba kembali
          </span>
        </p>
      )}
      <div
        className="mt-20 rounded-1"
        style={{
          minHeight: 520,
          maxHeight: 720,
          overflowY: 'auto',
          backgroundColor: '#F5F5F5'
        }}>
        {data &&
          data.map((history) => (
            <div
              key={history.id}
              style={{
                backgroundColor: '#ffffff',
                marginBottom: 16,
                fontSize: 14,
                padding: '8px 12px',
                borderLeft: 'solid 5px ' + history.color
              }}>
              <span className="d-block fw-600 text-14 text-dark">{history.title}</span>
              <p className="text-14 text-dark">{history.message}</p>
              <span className="d-block mt-2 text-12">{history.date}</span>
            </div>
          ))}
      </div>
    </>
  );
};

export default RefundHistory;
